import { type UpdatePureWaveSettingRequestModel } from '@/shared/api'

import { type MyWaveFormModel } from './my-wave-form.schema'

export function getPureWaveSettingsRequestByFormValues(
  values: MyWaveFormModel,
): {
  data: UpdatePureWaveSettingRequestModel
} {
  return {
    data: {
      podcastFrequency: values.podcastFrequency,
      trackFrequency: values.trackFrequency,
    },
  }
}
